import styled from "styled-components";

import { CircularLoaderContainer } from "shared/components/atoms/CircularLoader/styles";

export const USerGroupsSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 2rem;

  ${CircularLoaderContainer} {
    align-items: center;
    height: 1rem;
    width: 1rem;
  }
`;
